export const getExtensionFromName = (fileName) => fileName.match(/\.[^.]*$/)?.[0]?.replace('.', '') || '';

/**
 * @param {Number} size - bit
 * @param {Boolean} options - {
 *  byte: Booolean = true, // (covert bit to byte)
 *  limit: 999,
 *  fixed: 2
 * }
 * @returns String
 */
export const getFileSize = (size = 0, options = {}, deep = 0) => {
  const byte = options?.byte ?? true;
  const limit = options?.limit || 999;
  const fixed = options?.fixed ?? 2;

  const bitAppend = 'ит';
  const deepAppend = ['Б', 'КБ', 'МБ', 'ГБ', 'ТБ'];

  let currentSize = size;
  if (byte && !deep) {
    currentSize /= 8;
  }
  if (limit < currentSize && deep < deepAppend.length) {
    return getFileSize(currentSize / 1024, options, deep + 1);
  }
  return `${currentSize.toFixed(fixed)} ${deepAppend[deep]}${!byte ? bitAppend : ''}`;
};
